import Vue from 'vue'
import Router from 'vue-router'
import {Homepage, Search, VehicleDetail, NotFound, Sell, Who, Contacts, Privacy, ThankYou } from '../pages'

Vue.use(Router)

const router = new Router({
    mode: "history",
    routes: [
        {
            path: '/',
            name: 'home',
            component: Homepage
        },
        {
            path: '/cerca/:category?',
            props: true,
            name: 'search',
            component: Search
        },
        {
            path: '/vehicle/:id',
            redirect: to => {
                return `/annuncio/${to.params.id}`
            }
        },
        {
            path: '/annuncio/:id',
            name: 'vehicle',
            props: true,
            component: VehicleDetail
        },
        {
            path: '/vendi',
            name: 'sell',
            component: Sell
        },
        {
            path: '/chi-siamo',
            name: 'who',
            component: Who
        },
        {
            path: '/contattaci',
            name: 'contacts',
            component: Contacts
        },
        {
            path: '/grazie',
            name: 'thankyou',
            component: ThankYou
        },
        {
            path: '/privacy-policy',
            name: 'privacy',
            component: Privacy
        },
        {
            path: '*',
            name: 'notFound',
            component: NotFound
        },
    ],
    linkActiveClass: "active",
    linkExactActiveClass: "exact-active",
    scrollBehavior() {
        return {x: 0, y: 0}
    }
})

router.beforeEach((to, from, next) => {
    next()
})

router.afterEach((to) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        event: 'virtualPageView',
        page: to.fullPath,
    })
})

export default router